import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
/* Layout */
import Layout from '@/layout';
import { require } from '@/utils/index';
//服务协议和隐私政策
const zh_routes = [
  {
    path: '/chService',
    name: '服务协议',
    component: () => import('@/views/servicePolicy/chService.vue'),
    meta: {  }
  },
  {
    path: '/chPolicy',
    name: '隐私政策',
    component: () => import('@/views/servicePolicy/chPolicy.vue'),
    meta: {  }
  }
]
const en_routes = [
  {
    path: '/enService',
    name: 'Service Terms',
    component: () => import('@/views/servicePolicy/enService.vue'),
    meta: {hide: true}
  },
  {
    path: '/enPolicy',
    name: 'Privacy Policy',
    component: () => import('@/views/servicePolicy/enPolicy.vue'),
    meta: {hide: true}
  }
]
const ru_routes = [
  {
    path: '/chService',
    name: 'Соглашение об услугах',
    component: () => import('@/views/servicePolicy/chService.vue'),
    meta: {  }
  },
  {
    path: '/chPolicy',
    name: 'Политика конфиденциальности',
    component: () => import('@/views/servicePolicy/chPolicy.vue'),
    meta: {  }
  }
]
const centerRoutes_chinese = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
    meta: { title: '登录', icon: 'home', hide: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/center/register.vue'),
    meta: { title: '注册', icon: 'home', hide: true }
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/center/resetPassword.vue'),
    meta: { title: '重置密码', icon: 'home', hide: true }
  },
  {
    path: '/confirmPassword',
    name: 'ConfirmPassword',
    component: () => import('@/views/confirmPassword.vue'),
    meta: { title: '确认密码', icon: 'home', hide: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: '仪表盘', icon: require('@/assets/images/center/menu_dashboard.png'), hide: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/center/dashboard/dashboard.vue')
      }
    ]
  },
  {
    path: '/senior',
    component: Layout,
    redirect: '/senior/price',
    name: 'sProduct',
    meta: { title: '高级住宅代理', icon: require('@/assets/images/center/pre.png') },
    children: [
      {
        path: 'price',
        name: 'sPrice',
        component: () => import('@/views/center/senior/price.vue'),
        meta: { title: '价格', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'sObtain',
        component: () => import('@/views/center/senior/obtain.vue'),
        meta: { title: '获取IP', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'sPlans',
        component: () => import('@/views/center/senior/plans.vue'),
        meta: { title: '流量明细', icon: require('@/assets/images/center/menu_plans.png') }
        },
        {
            path: 'completeOrderSenior',
            name: 'completeOrderSenior',
            component: () => import('@/views/completeOrderSenior.vue'),
            meta: { show:false,title: '完成订单', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
          }
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/price',
    name: 'Product',
    meta: { title: '住宅代理', icon: require('@/assets/images/center/home_icon.png') },
    children: [
      {
        path: 'price',
        name: 'Price',
        component: () => import('@/views/center/product/price.vue'),
        meta: { title: '价格', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'ProxyAccess',
        component: () => import('@/views/center/product/proxyAccess.vue'),
        meta: { title: '获取IP', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'Plans',
        component: () => import('@/views/center/product/plans.vue'),
        meta: { title: '流量明细', icon: require('@/assets/images/center/menu_plans.png') }
        },
        {
            path: 'completeOrder',
            name: 'CompleteOrder',
            component: () => import('@/views/completeOrder.vue'),
            meta: { show:false,title: '完成订单', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
          }
    ]
  },
  {
    path: '/mobility',
    component: Layout,
    redirect: '/mobility/price',
    name: 'Mobility',
    meta: { title: '移动代理', icon: require('@/assets/images/center/home_mobile.png') },
    children: [
      {
        path: 'price',
        name: 'mPrice',
        component: () => import('@/views/center/mobility/price.vue'),
        meta: { title: '价格', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'mObtain',
        component: () => import('@/views/center/mobility/obtain.vue'),
        meta: { title: '获取IP', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'mPlans',
        component: () => import('@/views/center/mobility/plans.vue'),
        meta: { title: '流量明细', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderMobile',
        name: 'completeOrderMobile',
        component: () => import('@/views/completeOrderMobile.vue'),
        meta: { show:false,title: '完成订单', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      },
    ]
  },
  {
    path: '/ISP',
    component: Layout,
    redirect: '/ISP/price',
    name: 'ISP',
    meta: { title: 'ISP代理', icon: require('@/assets/images/center/home-isp.png') },
    children: [
      {
        path: 'price',
        name: 'ispPrice',
        component: () => import('@/views/center/isp/price.vue'),
        meta: { title: '价格', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ispPlans',
        component: () => import('@/views/center/isp/plans.vue'),
        meta: { title: 'IP明细', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'dottedCompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show:false,title: '完成订单', icon: require('@/assets/images/center/menu_rocket_wallet.png') }

      }
    ]
  },
  {
    path: '/IPv4',
    component: Layout,
    redirect: '/IPv4/price',
    name: 'IPv4',
    meta: { title: 'IPv4代理', icon: require('@/assets/images/center/home-ipv4.png') },
    children: [
      {
        path: 'price',
        name: 'ipv4Price',
        component: () => import('@/views/center/ipv4/price.vue'),
        meta: { title: '价格', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ipv4Plans',
        component: () => import('@/views/center/ipv4/plans.vue'),
        meta: { title: 'IP明细', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'ipv4CompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show:false,title: '完成订单', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      }
    ]
  },
  {
    path: '/IPv6',
    component: Layout,
    redirect: '/IPv6/price',
    name: 'IPv6',
    meta: { title: 'IPv6代理', icon: require('@/assets/images/center/home-ipv6.png') },
    children: [
      {
        path: 'price',
        name: 'ipv6Price',
        component: () => import('@/views/center/ipv6/price.vue'),
        meta: { title: '价格', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ipv6Plans',
        component: () => import('@/views/center/ipv6/plans.vue'),
        meta: { title: 'IP明细', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'ipv6CompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show:false,title: '完成订单', icon: require('@/assets/images/center/menu_rocket_wallet.png') }

      }
    ]
  },
  {
    path: '/Infinite',
    component: Layout,
    redirect: '/Infinite/price',
    name: 'Infinite',
    meta: { title: '无限代理', icon: require('@/assets/images/center/home_infinte.png') },
    children: [
      {
        path: 'price',
        name: 'enPrice',
        component: () => import('@/views/center/Infinite/price.vue'),
        meta: { title: '价格', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'plans',
        name: 'ePlans',
        component: () => import('@/views/center/Infinite/plans.vue'),
        meta: { title: 'IP明细', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderInfinite',
        name: 'completeOrderInfinite',
        component: () => import('@/views/completeOrderInfinite.vue'),
        meta: { show:false,title: '完成订单', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
  
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/profile',
    name: 'Account',
    meta: { title: '账户管理', icon: require('@/assets/images/center/menu_proxy_accounts.png') },
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/center/account/profile.vue'),
        meta: { title: '个人信息', icon: require('@/assets/images/center/profile.png') }
      },
      {
        path: 'billings',
        name: 'Billings',
        component: () => import('@/views/center/account/billings.vue'),
        meta: { title: '购买记录', icon: require('@/assets/images/center/menu_billings.png') }
      },
    ]
  },
  {
    path: '/rocketWallet',
    component: Layout,
    redirect: '/rocketWallet/index',
    meta: { title: 'Rocket钱包', icon: require('@/assets/images/center/menu_rocket_wallet.png'), hide: true },
    children: [
      {
        path: 'index',
        name: 'rocketWalletIndex',
        component: () => import('@/views/center/rocketWallet.vue')
      },
      {
        path: 'completeOrderWallet',
        name: 'CompleteOrderWallet',
        component: () => import('@/views/completeOrderWallet.vue'),
        meta: { title: '完成订单', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
        },


    ]
    },
    {
        path: '/referralProgram',
        component: Layout,
        redirect: '/referralProgram/index',
        meta: { title: '推广分佣', icon: require('@/assets/images/center/menu_referral.png'), hide: true },
        children: [
          {
            path: 'index',
            name: 'ReferralProgramIndex',
            component: () => import('@/views/center/account/referralProgram.vue'),          },
        ]
      },
      {
        path: '/partner',
        component: Layout,
        redirect: '/partner/partner',
        meta: { title: '合作伙伴', icon: require('@/assets/images/center/partner.png'), hide: true },
        children: [
          {
            path: 'partner',
            name: 'Partner',
            component: () => import('@/views/center/partner/partner.vue'),          },
        ]
      },
  // {
  //   path: '/helpCenter',
  //   meta: { title: '帮助中心', icon: require('@/assets/images/center/menu_help.png') }
  // }
];
const centerRoutes_english = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
    meta: { title: 'Login', icon: 'home', hide: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/center/register.vue'),
    meta: { title: 'Register', icon: 'home', hide: true }
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/center/resetPassword.vue'),
    meta: { title: 'Reset password', icon: 'home', hide: true }
  },
  {
    path: '/confirmPassword',
    name: 'ConfirmPassword',
    component: () => import('@/views/confirmPassword.vue'),
    meta: { title: 'Confirm password', icon: 'home', hide: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: 'Dashboard', icon: require('@/assets/images/center/menu_dashboard.png'), hide: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/center/dashboard/dashboard.vue')
      }
    ]
  },
  {
    path: '/senior',
    component: Layout,
    redirect: '/senior/price',
    name: 'Senior',
    meta: { title: 'Premium Proxy', icon: require('@/assets/images/center/pre.png') },
    children: [
      {
        path: 'price',
        name: 'sPrice',
        component: () => import('@/views/center/senior/price.vue'),
        meta: { title: 'Price', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'sObtain',
        component: () => import('@/views/center/senior/obtain.vue'),
        meta: { title: 'Proxy Access', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'sPlans',
        component: () => import('@/views/center/senior/plans.vue'),
        meta: { title: 'Traffic Details', icon: require('@/assets/images/center/menu_plans.png') }
        },
        {
            path: 'completeOrderSenior',
            name: 'completeOrderSenior',
            component: () => import('@/views/completeOrderSenior.vue'),
            meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
          }
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/price',
    name: 'Product',
    meta: { title: 'Residential Proxy', icon: require('@/assets/images/center/home_icon.png') },
    children: [
      {
        path: 'price',
        name: 'Price',
        component: () => import('@/views/center/product/price.vue'),
        meta: { title: 'Price', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'ProxyAccess',
        component: () => import('@/views/center/product/proxyAccess.vue'),
        meta: { title: 'Proxy Access', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'Plans',
        component: () => import('@/views/center/product/plans.vue'),
        meta: { title: 'Traffic Details', icon: require('@/assets/images/center/menu_plans.png') }
        },
        {
            path: 'completeOrder',
            name: 'CompleteOrder',
            component: () => import('@/views/completeOrder.vue'),
            meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
          },

    ]
  },
  {
    path: '/mobility',
    component: Layout,
    redirect: '/mobility/price',
    name: 'Mobility',
    meta: { title: 'Mobile Proxy', icon: require('@/assets/images/center/home_mobile.png') },
    children: [
      {
        path: 'price',
        name: 'mPrice',
        component: () => import('@/views/center/mobility/price.vue'),
        meta: { title: 'Price', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'mObtain',
        component: () => import('@/views/center/mobility/obtain.vue'),
        meta: { title: 'Proxy Access', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'mPlans',
        component: () => import('@/views/center/mobility/plans.vue'),
        meta: { title: 'Traffic Details', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderMobile',
        name: 'completeOrderMobile',
        component: () => import('@/views/completeOrderMobile.vue'),
        meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      },
    ]
  },
  // {
  //   path: '/data',
  //   component: Layout,
  //   redirect: '/data/price',
  //   name: 'Data',
  //   meta: { title: 'Data Center', icon: require('@/assets/images/center/home_data.png') },
  //   children: [
  //     {
  //       path: 'price',
  //       name: 'dPrice',
  //       component: () => import('@/views/center/data/price.vue'),
  //       meta: { title: 'Price', icon: require('@/assets/images/center/menu_price.png') }
  //     },
  //     {
  //       path: 'proxyAccess',
  //       name: 'dObtain',
  //       component: () => import('@/views/center/data/obtain.vue'),
  //       meta: { title: 'Proxy Access', icon: require('@/assets/images/center/menu_proxy.png') }
  //     },
  //     {
  //       path: 'plans',
  //       name: 'dPlans',
  //       component: () => import('@/views/center/data/plans.vue'),
  //       meta: { title: 'Traffic Details', icon: require('@/assets/images/center/menu_plans.png') }
  //     },
  //     {
  //       path: 'completeOrderData',
  //       name: 'completeOrderData',
  //       component: () => import('@/views/completeOrderData.vue'),
  //       meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
  //     }
  //   ]
  // },
  {
    path: '/ISP',
    component: Layout,
    redirect: '/ISP/price',
    name: 'ISP',
    meta: { title: 'ISP Proxy', icon: require('@/assets/images/center/home-isp.png') },
    children: [
      {
        path: 'price',
        name: 'ispPrice',
        component: () => import('@/views/center/isp/price.vue'),
        meta: { title: 'price', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ispPlans',
        component: () => import('@/views/center/isp/plans.vue'),
        meta: { title: 'IP Details', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'dottedCompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }

      }
    ]
  },
  {
    path: '/IPv4',
    component: Layout,
    redirect: '/IPv4/price',
    name: 'IPv4',
    meta: { title: 'IPv4 Proxy', icon: require('@/assets/images/center/home-ipv4.png') },
    children: [
      {
        path: 'price',
        name: 'ipv4Price',
        component: () => import('@/views/center/ipv4/price.vue'),
        meta: { title: 'price', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ipv4Plans',
        component: () => import('@/views/center/ipv4/plans.vue'),
        meta: { title: 'IP Details', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'ipv4CompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      }
    ]
  },
  {
    path: '/IPv6',
    component: Layout,
    redirect: '/IPv6/price',
    name: 'IPv6',
    meta: { title: 'IPv6 Proxy', icon: require('@/assets/images/center/home-ipv6.png') },
    children: [
      {
        path: 'price',
        name: 'ipv6Price',
        component: () => import('@/views/center/ipv6/price.vue'),
        meta: { title: 'price', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ipv6Plans',
        component: () => import('@/views/center/ipv6/plans.vue'),
        meta: { title: 'IP Details', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'ipv6CompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }

      }
    ]
  },
  {
    path: '/Infinite',
    component: Layout,
    redirect: '/Infinite/price',
    name: 'Infinite',
    meta: { title: 'Infinite Proxy', icon: require('@/assets/images/center/home_infinte.png') },
    children: [
      {
        path: 'price',
        name: 'enPrice',
        component: () => import('@/views/center/Infinite/price.vue'),
        meta: { title: 'price', icon: require('@/assets/images/center/menu_price.png') }
      },
  
      {
        path: 'plans',
        name: 'ePlans',
        component: () => import('@/views/center/Infinite/plans.vue'),
        meta: { title: 'IP Details', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderInfinite',
        name: 'completeOrderInfinite',
        component: () => import('@/views/completeOrderInfinite.vue'),
        meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
  
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/profile',
    name: 'Account',
    meta: { title: 'Account', icon: require('@/assets/images/center/menu_proxy_accounts.png') },
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/center/account/profile.vue'),
        meta: { title: 'Profile', icon: require('@/assets/images/center/profile.png') }
      },
      {
        path: 'billings',
        name: 'Billings',
        component: () => import('@/views/center/account/billings.vue'),
        meta: { title: 'Billings', icon: require('@/assets/images/center/menu_billings.png') }
      },
    ]
  },
  {
    path: '/rocketWallet',
    component: Layout,
    redirect: '/rocketWallet/index',
    meta: { title: 'Rocket Wallet', icon: require('@/assets/images/center/menu_rocket_wallet.png'), hide: true },
    children: [
      {
        path: 'index',
        name: 'rocketWalletIndex',
        component: () => import('@/views/center/rocketWallet.vue')
        },
        {
            path: 'completeOrderWallet',
            name: 'CompleteOrderWallet',
            component: () => import('@/views/completeOrderWallet.vue'),
            meta: { title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
            },

    ]
    },
  {
        path: '/referralProgram',
        component: Layout,
        redirect: '/referralProgram/index',
        meta: { title: 'Affiliate', icon: require('@/assets/images/center/menu_referral.png'), hide: true },
        children: [
          {
            path: 'index',
            name: 'ReferralProgramIndex',
            component: () => import('@/views/center/account/referralProgram.vue'),          },
        ]
   },
  {
    path: '/partner',
    component: Layout,
    redirect: '/partner/partner',
    meta: { title: 'Partner', icon: require('@/assets/images/center/partner.png'), hide: true },
    children: [
      {
        path: 'partner',
        name: 'Partner',
        component: () => import('@/views/center/partner/partner.vue'),          },
    ]
  },
  // {
  //   path: '/helpCenter',
  //   meta: { title: 'Help center', icon: require('@/assets/images/center/menu_help.png') }
  // }
];
const centerRoutes_russian = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login.vue'),
    meta: { title: 'Регистрация', icon: 'home', hide: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/center/register.vue'),
    meta: { title: 'Регистрация', icon: 'home', hide: true }
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/center/resetPassword.vue'),
    meta: { title: 'Сбросить пароль', icon: 'home', hide: true }
  },
  {
    path: '/confirmPassword',
    name: 'ConfirmPassword',
    component: () => import('@/views/confirmPassword.vue'),
    meta: { title: 'Подтвердить пароль', icon: 'home', hide: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: 'приборная панель', icon: require('@/assets/images/center/menu_dashboard.png'), hide: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/center/dashboard/dashboard.vue')
      }
    ]
  },
  {
    path: '/senior',
    component: Layout,
    redirect: '/senior/price',
    name: 'sProduct',
    meta: { title: 'Старший жилищный агент', icon: require('@/assets/images/center/pre.png') },
    children: [
      {
        path: 'price',
        name: 'sPrice',
        component: () => import('@/views/center/senior/price.vue'),
        meta: { title: 'Цены', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'sObtain',
        component: () => import('@/views/center/senior/obtain.vue'),
        meta: { title: 'Получение IP', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'sPlans',
        component: () => import('@/views/center/senior/plans.vue'),
        meta: { title: 'Разбивка расхода', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderSenior',
        name: 'completeOrderSenior',
        component: () => import('@/views/completeOrderSenior.vue'),
        meta: { show:false,title: 'Выполнение заказа', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      }
    ]
  },
  {
    path: '/product',
    component: Layout,
    redirect: '/product/price',
    name: 'Product',
    meta: { title: 'Жилищный агент', icon: require('@/assets/images/center/home_icon.png') },
    children: [
      {
        path: 'price',
        name: 'Price',
        component: () => import('@/views/center/product/price.vue'),
        meta: { title: 'Цены', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'ProxyAccess',
        component: () => import('@/views/center/product/proxyAccess.vue'),
        meta: { title: 'Получение IP', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'Plans',
        component: () => import('@/views/center/product/plans.vue'),
        meta: { title: 'Разбивка расхода', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrder',
        name: 'CompleteOrder',
        component: () => import('@/views/completeOrder.vue'),
        meta: { show:false,title: 'Выполнение заказа', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      }
    ]
  },
  {
    path: '/mobility',
    component: Layout,
    redirect: '/mobility/price',
    name: 'Mobility',
    meta: { title: 'Мобильный прокси', icon: require('@/assets/images/center/home_mobile.png') },
    children: [
      {
        path: 'price',
        name: 'mPrice',
        component: () => import('@/views/center/mobility/price.vue'),
        meta: { title: 'Цены', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'mObtain',
        component: () => import('@/views/center/mobility/obtain.vue'),
        meta: { title: 'Получение IP', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'mPlans',
        component: () => import('@/views/center/mobility/plans.vue'),
        meta: { title: 'Разбивка расхода', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderMobile',
        name: 'completeOrderMobile',
        component: () => import('@/views/completeOrderMobile.vue'),
        meta: { show:false,title: 'Выполнение заказа', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      }
    ]
  },
  {
    path: '/data',
    component: Layout,
    redirect: '/data/price',
    name: 'Data',
    meta: { title: 'Центр данных', icon: require('@/assets/images/center/home_data.png') },
    children: [
      {
        path: 'price',
        name: 'dPrice',
        component: () => import('@/views/center/data/price.vue'),
        meta: { title: 'Цены', icon: require('@/assets/images/center/menu_price.png') }
      },
      {
        path: 'proxyAccess',
        name: 'dObtain',
        component: () => import('@/views/center/data/obtain.vue'),
        meta: { title: 'Получение IP', icon: require('@/assets/images/center/menu_proxy.png') }
      },
      {
        path: 'plans',
        name: 'dPlans',
        component: () => import('@/views/center/data/plans.vue'),
        meta: { title: 'Разбивка расхода', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderData',
        name: 'completeOrderData',
        component: () => import('@/views/completeOrderData.vue'),
        meta: { show:false,title: 'Выполнение заказа', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      }
    ]
  },
  {
    path: '/ISP',
    component: Layout,
    redirect: '/ISP/price',
    name: 'ISP',
    meta: { title: 'интернет-провайдер', icon: require('@/assets/images/center/home-isp.png') },
    children: [
      {
        path: 'price',
        name: 'ispPrice',
        component: () => import('@/views/center/isp/price.vue'),
        meta: { title: 'цена', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ispPlans',
        component: () => import('@/views/center/isp/plans.vue'),
        meta: { title: 'Данные IP-адреса', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'dottedCompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show: false, title: 'Выполнение заказа', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      },
    ]
  },
  {
    path: '/IPv4',
    component: Layout,
    redirect: '/IPv4/price',
    name: 'IPv4',
    meta: { title: 'IPTV', icon: require('@/assets/images/center/home-ipv4.png') },
    children: [
      {
        path: 'price',
        name: 'ipv4Price',
        component: () => import('@/views/center/ipv4/price.vue'),
        meta: { title: 'цена', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ipv4Plans',
        component: () => import('@/views/center/ipv4/plans.vue'),
        meta: { title: 'Данные IP-адреса', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'ipv4CompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show:false,title: 'Complete order', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      }
    ]
  },
  {
    path: '/IPv6',
    component: Layout,
    redirect: '/IPv6/price',
    name: 'IPv6',
    meta: { title: 'ipvsh', icon: require('@/assets/images/center/home-ipv6.png') },
    children: [
      {
        path: 'price',
        name: 'ipv6Price',
        component: () => import('@/views/center/ipv6/price.vue'),
        meta: { title: 'цена', icon: require('@/assets/images/center/menu_price.png') }
      },

      {
        path: 'plans',
        name: 'ipv6Plans',
        component: () => import('@/views/center/ipv6/plans.vue'),
        meta: { title: 'Данные IP-адреса', icon: require('@/assets/images/center/menu_plans.png') }
      },
      {
        path: 'completeOrderstatsth',
        name: 'ipv6CompleteOrder',
        component: () => import('@/views/completeOrderstatsth.vue'),
        meta: { show: false, title: 'Выполнение заказа', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      },
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: '/account/profile',
    name: 'Account',
    meta: { title: 'Управление счетами', icon: require('@/assets/images/center/menu_proxy_accounts.png') },
    children: [
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/center/account/profile.vue'),
        meta: { title: 'Личная информация', icon: require('@/assets/images/center/profile.png') }
      },
      {
        path: 'billings',
        name: 'Billings',
        component: () => import('@/views/center/account/billings.vue'),
        meta: { title: 'Учет покупок', icon: require('@/assets/images/center/menu_billings.png') }
      },
    ]
  },

  {
    path: '/rocketWallet',
    component: Layout,
    redirect: '/rocketWallet/index',
    meta: { title: 'Кошелек Rocket', icon: require('@/assets/images/center/menu_rocket_wallet.png'), hide: true },
    children: [
      {
        path: 'index',
        name: 'rocketWalletIndex',
        component: () => import('@/views/center/rocketWallet.vue')
      },
      {
        path: 'completeOrderWallet',
        name: 'CompleteOrderWallet',
        component: () => import('@/views/completeOrderWallet.vue'),
        meta: { title: 'Выполнение заказа', icon: require('@/assets/images/center/menu_rocket_wallet.png') }
      },


    ]
  },

  {
    path: '/referralProgram',
    component: Layout,
    redirect: '/referralProgram/index',
    meta: { title: 'Поощрение разделения труда', icon: require('@/assets/images/center/menu_referral.png'), hide: true },
    children: [
      {
        path: 'index',
        name: 'ReferralProgramIndex',
        component: () => import('@/views/center/account/referralProgram.vue'),          },
    ]
  },
  {
    path: '/helpCenter',
    meta: { title: 'Центр помощи', icon: require('@/assets/images/center/menu_help.png') }
  }
];
const urlParams = new URLSearchParams(window.location.search);
const langParam = urlParams.get('lang');

// 根据查询参数设置 localStorage 中的语言
if (langParam === 'zh') {
  localStorage.setItem('langrage', 'chinese');
} else if(langParam === 'en'){
  localStorage.setItem('langrage', 'english'); // 默认语言
} else {
}



const lang = localStorage.getItem('langrage');
console.log('当前语言', lang)
let centerRoutes = [];
let serviceRoutes = [];
if (lang === 'chinese') {
  centerRoutes = centerRoutes_chinese;
  serviceRoutes = zh_routes;
} else if (lang === 'english') {
  centerRoutes = centerRoutes_english;
  serviceRoutes = en_routes;
} else if (lang === 'russian') {
  centerRoutes = centerRoutes_russian;
  serviceRoutes = ru_routes;
} else {
  localStorage.setItem('langrage', 'english');
  centerRoutes = centerRoutes_english;
  serviceRoutes = en_routes;
}
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [...centerRoutes,...serviceRoutes]
});
// 有用户缓存时立即放行；仅在 token 存在但缓存缺失时初始化一次用户信息。
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');
  const routes = ['/register', '/Register', '/login', '/resetPassword', '/confirmPassword','/chService','/enService','/chPolicy','/enPolicy'];

  if (routes.includes(to.path)) {
    next();
    return;
  }

  if (!token) {
    next('/login');
    return;
  }

  if (store.state.user.userInfo) {
    next();
    return;
  }

  try {
    await store.dispatch('user/getInfo');
    next();
  } catch (error) {
    console.warn('[router] getInfo failed:', error);
    next('/login');
  }
});
export default router;
